<script lang="ts">
    export let link = '';
    export let text = '';
</script>

<a href={link} target="_blank" class="font-ui underline" rel="noreferrer" style="color: inherit;">
    {text}
</a>
